<template>
  <section class="app-main">
    <div class="top-bar">
      <el-select v-model="activity" placeholder="请选择" @change="handleData">
            <el-option
            v-for="item in activity_list"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
      </el-select>
      <el-date-picker
        v-model="fixDate"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px; margin:0 15px"
      ></el-date-picker>
      <el-input
        placeholder="输入用户名称或者手机号"
        v-model="value"
        @change="search"
        style="width: 200px; margin-right: 25px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button  class="top-btn" type="primary" plain @click="handleBatch()">群发短信</el-button>
    </div>
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="handleChecked"
        empty-text="暂无用户"
        height="560"
      >
        <el-table-column prop="activity_name"  label="活动名称" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="username" label="用户账号" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{scope.row.phone?scope.row.phone:'-'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{scope.row.email?scope.row.email:'-'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="lottery_code" label="抽奖码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{scope.row.lottery_code?scope.row.lottery_code:'-'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="user_source" label="获取途径" align="center" width="110" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="activity_created_at" label="参与时间" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="created_at" label="领取时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.is_receive == 1? scope.row.receive_time : '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="is_sms" label="短信" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.is_sms == 0 ? '未发送' : '已发送'}}</span>
          </template>
        </el-table-column>
         <el-table-column prop="" label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-button :type="scope.row.is_receive == 0?'success':'info'" size="mini" :disabled="scope.row.is_receive == 0? false : true" @click="getCode(scope.row.activity_users_id)">{{scope.row.is_receive == 0?'领取':'已领取'}}</el-button>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>
  </section>
</template>


<script>
import { marketing_member_list, marketing_member_receive, marketing_member_sms } from "@/api/market.js";

export default {
  name: "UserList",
  data() {
    return {
      value: "",
      activity: '',
      activity_list: [],
      tableData: [],
      page: 1,
      size: 20,
      total: 0,
      ids: [], // table 选中数据的 id 数组集合
      fixDate: [],
    };
  },
  methods: {
    // 搜索会员
    search() {
      this.page = 1;
      this.handleData();
    },

    // 日期查询搜索
    handleDate() {
      this.page = 1;
      this.handleData();
    },
    // 获取会员数据
    handleData() {
      let params = {
        page: this.page,
      };
      if (this.value != "") {
        params.search = this.value;
      }

      if (this.fixDate && this.fixDate.length != 0) {
        params.start_date_search = this.fixDate[0];
        params.end_date_search = this.fixDate[1];
      }
      if (this.activity != "") {
         params.activity = this.activity
      }
      marketing_member_list(params).then((res) => {
        if (res) {
          this.activity_list = res.activity_list;
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page;
        } else {
          this.tableData = [];
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.handleData();
    },
    // 领取时间
    getCode(id) {
        marketing_member_receive(id).then(res => {  
            if(res){
                this.handleData();
            }
        })
    },
    // 群发短信
    handleBatch() {
      marketing_member_sms().then(res => {
        if(res) {
          this.$message({
            type: 'success',
            message: res.msg
          });
        }
      })
    }
  },
  created() {
    this.handleData();
  },
  activated() {
    this.handleData();
  },
};
</script>

<style lang="less" scoped>
section {
  .top-btn {
    width: 100px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
}
</style>